(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ankyra-faq"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ak-accordions'))customElements.define('ak-accordions',class extends HTMLElement{connectedCallback(){this.controller?.abort();this.controller=new AbortController();this.addEventListener('click',async e=>{const s=e.target.closest('summary');if(!s)return;const d=s.parentElement;if(!this.contains(d))return;e.preventDefault();if(d.dataset.busy)return;d.dataset.busy='true';const opening=!d.open;const from=d.offsetHeight;if(opening)d.open=true;const to=opening?d.offsetHeight:s.offsetHeight;const a=d.animate([{height:from+'px'},{height:to+'px'}],{duration:matchMedia('(prefers-reduced-motion: reduce)').matches?0:450,easing:'cubic-bezier(.22,.7,.2,1)'});await a.finished.catch(()=>{});d.open=opening;delete d.dataset.busy;},{signal:this.controller.signal});}disconnectedCallback(){this.controller?.abort();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ankyra-footer"]) return;
  try {
    
if(!customElements.get('ak-support'))customElements.define('ak-support',class extends HTMLElement{connectedCallback(){this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;this.media=matchMedia('(max-width:649px)');const sync=()=>this.querySelectorAll('.akx-footer-col').forEach(d=>d.open=!this.media.matches);sync();this.media.addEventListener('change',sync,{signal});document.addEventListener('click',e=>{const opener=e.target.closest('[data-ak-help]');if(opener){const d=this.querySelector('[data-help-dialog="'+opener.dataset.akHelp+'"]');if(d){e.preventDefault();this.openDialog(d,opener);}}if(e.target.closest('[data-help-close]')&&this.contains(e.target))this.closeDialog(e.target.closest('dialog'));},{signal});this.querySelectorAll('dialog').forEach(d=>{d.addEventListener('cancel',e=>{e.preventDefault();this.closeDialog(d);},{signal});d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.closeDialog(d);}},{signal});});this.addEventListener('click',async e=>{const s=e.target.closest('.akx-footer-col>summary');if(!s)return;e.preventDefault();if(!this.media.matches)return;const d=s.parentElement;if(d.dataset.busy)return;d.dataset.busy='true';const opening=!d.open;const h=d.offsetHeight;if(opening)d.open=true;await d.animate([{height:h+'px'},{height:(opening?d.offsetHeight:s.offsetHeight)+'px'}],{duration:this.duration(450),easing:'cubic-bezier(.22,.7,.2,1)'}).finished.catch(()=>{});d.open=opening;delete d.dataset.busy;},{signal});}duration(n){return matchMedia('(prefers-reduced-motion: reduce)').matches?0:n;}openDialog(d,opener){if(d.open)return;const previous=this.querySelector('dialog[open]');if(previous){previous.close();}else this.opener=opener;if(opener?.dataset.topic){const option=d.querySelector('option[data-topic="'+opener.dataset.topic+'"]');if(option)option.selected=true;}d.showModal();document.body.classList.add('ak-lock');d.animate([{opacity:0,transform:'translateY(18px) scale(.985)'},{opacity:1,transform:'none'}],{duration:this.duration(550),easing:'cubic-bezier(.22,.7,.2,1)'});}async closeDialog(d){if(!d?.open||d.dataset.closing)return;d.dataset.closing='true';await d.animate([{opacity:1,transform:'none'},{opacity:0,transform:'translateY(10px) scale(.99)'}],{duration:this.duration(280),easing:'ease-in'}).finished.catch(()=>{});d.close();delete d.dataset.closing;if(!document.querySelector('dialog[open]'))document.body.classList.remove('ak-lock');this.opener?.focus({preventScroll:true});}disconnectedCallback(){this.controller?.abort();this.querySelectorAll('dialog[open]').forEach(d=>d.close());if(!document.querySelector('dialog[open]'))document.body.classList.remove('ak-lock');}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ankyra-size-guide"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ak-size-guide'))customElements.define('ak-size-guide',class extends HTMLElement{
 connectedCallback(){
  this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
  this.tabs=[...this.querySelectorAll('[role=tab]')];
  this.addEventListener('click',event=>{const tab=event.target.closest('[role=tab]');if(tab)this.select(tab);const preset=event.target.closest('[data-akp-preset]');if(preset)this.selectPreset(preset);},{signal});
  this.addEventListener('keydown',event=>{const i=this.tabs.indexOf(event.target);if(i<0)return;let next;if(event.key==='ArrowRight')next=(i+1)%this.tabs.length;if(event.key==='ArrowLeft')next=(i-1+this.tabs.length)%this.tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=this.tabs.length-1;if(next!==undefined){event.preventDefault();this.select(this.tabs[next]);this.tabs[next].focus();}},{signal});
  this.addEventListener('input',event=>{if(event.target.matches('[data-akp-width],[data-akp-length]'))this.updateArea();},{signal});
  document.addEventListener('shopify:block:select',event=>{const tab=this.tabs.find(item=>item.dataset.blockId===event.detail.blockId);if(tab)this.select(tab);},{signal});
  if(this.tabs.length)this.select(this.tabs.find(tab=>tab.getAttribute('aria-selected')==='true')||this.tabs[0],false);
  this.updateArea();
 }
 select(tab,animate=true){
  this.tabs.forEach(item=>{const active=item===tab;item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;const panel=this.querySelector('[id="'+item.getAttribute('aria-controls')+'"]');if(panel)panel.hidden=!active;});
  this.dataset.layout=tab.dataset.plan;this.querySelector('[data-akp-room-label]').textContent=tab.textContent.replace(/^\s*0\d\s*/,'').trim();
  this.querySelectorAll('[data-akp-tips]').forEach(tips=>tips.hidden=tips.dataset.akpTips!==tab.dataset.plan);
  const panel=this.querySelector('[id="'+tab.getAttribute('aria-controls')+'"]');const choice=panel?.querySelector('[data-akp-preset][aria-pressed=true]')||panel?.querySelector('[data-akp-preset]');if(choice)this.selectPreset(choice,animate);
 }
 selectPreset(button,animate=true){
  button.closest('.akp-presets').querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
  const use=this.querySelector('[data-akp-scene]');use.setAttribute('href','#AkScene-'+this.dataset.sectionId+'-'+button.dataset.akpPreset);
  this.querySelector('[data-akp-example]').textContent=(button.dataset.quantity==='2'?'2 × ':'')+button.dataset.width+' × '+button.dataset.length+' cm';
  this.querySelector('[data-akp-placement-title]').textContent=button.dataset.title;this.querySelector('[data-akp-placement-note]').textContent=button.dataset.note;
  this.querySelector('[data-akp-width]').value=button.dataset.width;this.querySelector('[data-akp-length]').value=button.dataset.length;this.updateArea();
  this.sceneAnimation?.cancel();if(animate&&!matchMedia('(prefers-reduced-motion:reduce)').matches)this.sceneAnimation=this.querySelector('[data-akp-scene-live]').animate([{opacity:.2,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:550,easing:'cubic-bezier(.2,0,.2,1)'});
 }
 updateArea(){
  const width=this.querySelector('[data-akp-width]');const length=this.querySelector('[data-akp-length]');const output=this.querySelector('[data-akp-area]');const valid=width.value!==''&&length.value!==''&&width.validity.valid&&length.validity.valid;
  output.replaceChildren(document.createTextNode(valid?new Intl.NumberFormat(document.documentElement.lang||'tr',{maximumFractionDigits:2,minimumFractionDigits:2}).format(Number(width.value)*Number(length.value)/10000)+' ':'— '),Object.assign(document.createElement('small'),{textContent:'m²'}));
 }
 disconnectedCallback(){this.controller?.abort();this.sceneAnimation?.cancel();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
